// photosLanding.js
import pm1 from '../Assets/ADS/2.png'
import pm2 from '../Assets/ADS/5.png'
import pm3 from '../Assets/ADS/DML Flyer Design.jpg'
import pm5 from '../Assets/ADS/ad 6.png'
import pm6 from '../Assets/ADS/ad 3.png'
import pm7 from '../Assets/ADS/ad1.png'
import pm8 from '../Assets/ADS/TiesMart FinalAsset 2@4x-8.png'
import pm10 from '../Assets/ADS/ad4.png'
import pm11 from '../Assets/ADS/ad 6.png'
import pm12 from '../Assets/ADS/ad6.png'
import pm13 from '../Assets/ADS/ad7.png'
import pm14 from '../Assets/ADS/ad8.png'
import pm15 from '../Assets/ADS/ad9.png'
import pm17 from '../Assets/ADS/luce.png'
import pm18 from '../Assets/ADS/luceII.png'
import pm19 from '../Assets/ADS/new ad.png'
import pm20 from '../Assets/ADS/zad.png'
import pm21 from '../Assets/ADS/kud7.png'
import pm22 from '../Assets/ADS/adkuda.png'
import pm23 from '../Assets/ADS/new ad.png'
import pm24 from '../Assets/ADS/postinor1.png'
import pm25 from '../Assets/ADS/postinor2.png'
import pm26 from '../Assets/ADS/postinor3.png'
import pm27 from '../Assets/ADS/postinor4.png'
import pm28 from '../Assets/ADS/postinor5.png'
import pm29 from '../Assets/ADS/postinor6.png'
export const adPhotos = [
  {
    src: pm23,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm2,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm3,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm20,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm5,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm6,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm7,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm8,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm22,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: pm10,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm11,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: pm12,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm13,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: pm14,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm15,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm21,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm17,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: pm18,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm19,
    width: 1,
    height: 1,
    title: 'Promo',
  },

  {
    src: pm20,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm29,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },
  {
    src: pm21,
    width: 1,
    height: 1,
    title: 'Hero Visual',
  },

  {
    src: pm22,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm25,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm24,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm1,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm26,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm27,
    width: 1,
    height: 1,
    title: 'Promo',
  },
  {
    src: pm28,
    width: 1,
    height: 1,
    title: 'Promo',
  },
]
